import { MapLayerSwitcherOverlays } from "esdm-map/dist/map/MapLayerSwitcherOverlays"
import { IMap } from "esdm-map/dist/map/IMap";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore"
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { IWmsLayerGroup } from "esdm-map/dist/layers/groups/wms/interfaces/IWmsLayerGroup";
import ImageWMS from "ol/source/ImageWMS";

export class CustomMapLayerSwitcherOverlays extends MapLayerSwitcherOverlays {
    
    constructor(
        private map: IMap,
        private mapStore: IMapViewStore,
        private allLayers: LayerGroupCollections,
        private mappingTextPack: IMappingTextPack) {
        super(map, mapStore, allLayers, mappingTextPack);
    }

    //Modified to add width/height params to legend graphic request for listed building layer
    protected getLegendGraphic = (lyrGrp: IWmsLayerGroup): string => {
        let layerSource = <ImageWMS>lyrGrp.layers[0].olWmsLayer.getSource();
        let styleName: string = "";
        let params = {
            request: "GetLegendGraphic",
            version: "1.3.0",
            format: "image/png",
            layer: layerSource.getParams()["LAYERS"],
            service: "WMS",
            sld_version: "1.1.0",
            transparent: "true"
        }

        if (lyrGrp.ref == "ListedBuildings") {
            params["width"] = "30";
            params["height"] = "50";
        }

        lyrGrp.layers.forEach(l => {
            if (l.visible && l.styleName) {
                styleName = l.styleName;
            }
        });

        if (styleName) {
            params["style"] = styleName;
        }

        var queryString = Object.keys(params).map(function (key) {
            return key + '=' + encodeURIComponent(params[key])
        }).join('&');

        return `${layerSource.getUrl()}?${queryString}`;
    }
}
